import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import "../styles/slick.css";
import * as df from "../assets/images/01.png";
 import "react-alice-carousel/lib/alice-carousel.css";
import "jquery";
import "featherlight/release/featherlight.min.css";
import "featherlight/release/featherlight.min.js";
// import "../vendors/slick.min.js";

import VideoPlayer from "./Helper/VideoPlayer";
import Slider from "./Helper/Slider";

import MotionSickness from "./ResultContent/MotionSickness";
import Meniere from "./ResultContent/Meniere";
import VestibularMigraine from "./ResultContent/VestibularMigraine";
import CAVS  from "./ResultContent/CAVS";
import Neuritis  from "./ResultContent/Neuritis";
import Labyrinthitis  from "./ResultContent/Labyrinthitis";
import BPPV from "./ResultContent/BPPV";
import HCBPPV from "./ResultContent/HCBPPV";
import GufoniGeotropic from "./ResultContent/GufoniGeotropic";
import OH from "./ResultContent/OH";
import Aging from "./ResultContent/Aging";
import DegenerativeIllness from "./ResultContent/DegenerativeIllness";
import Medications from "./ResultContent/Medications";
import PPPD from "./ResultContent/PPPD";
import MundaneDizziness from "./ResultContent/MundaneDizziness";

import Share from "./Helper/Share";
import DoctorMaps from './Map/DoctorMaps';


export default class Result extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            selectedSlide:{
                no:0,
                title:"",
                video:"",
                img:"",
                products:[]
            },
            slides: [{
                no:13,
                title:"Meniere's Disease (MD)",
                video:"",
                img:"MinieresDisease.jpg",
                products:[
                    {
                        img:"strongboard.jpg",
                        caption:"StrongBoard Dynamic Stabilization Balance Board",
                        link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                    },
                    {
                        img:"balance-activity.jpg",
                        caption:"Hausmann Balance Activity Platform",
                        link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                    },
                    {
                        img:"Video-Frenzel-Vertigo.jpg",
                        caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                        link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                    },
                    {
                        img:"TQ-Solo.jpg",
                        caption:"TQ Solo Super Pulsed Lase",
                        link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                    },
                    {
                        img:"aeromat-elite.jpg",
                        caption:"Aeromat Elite Balance Beams, Set of 2",
                        link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                    },
                    {
                        img:"folding-balance.jpg",
                        caption:"EcoWise Folding Balance Beam",
                        link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                    },
                    {
                        img:"bed-wedge-pillow.jpg",
                        caption:"Bed Wedge Foam Positioning Pillow",
                        link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                    }
                ]
                },{
                    no:14,
                    title:"Vestibular Migraine",
                    video:"",
                    img:"VestibularMigraine.jpg",
                    products:[
                        {
                            img:"strongboard.jpg",
                            caption:"StrongBoard Dynamic Stabilization Balance Board",
                            link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                        },
                        {
                            img:"balance-activity.jpg",
                            caption:"Hausmann Balance Activity Platform",
                            link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                        },
                        {
                            img:"Video-Frenzel-Vertigo.jpg",
                            caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                            link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                        },
                        {
                            img:"TQ-Solo.jpg",
                            caption:"TQ Solo Super Pulsed Lase",
                            link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                        },
                        {
                            img:"aeromat-elite.jpg",
                            caption:"Aeromat Elite Balance Beams, Set of 2",
                            link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                        },
                        {
                            img:"folding-balance.jpg",
                            caption:"EcoWise Folding Balance Beam",
                            link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                        },
                        {
                            img:"bed-wedge-pillow.jpg",
                            caption:"Bed Wedge Foam Positioning Pillow",
                            link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                        }
                    ]
                    },{
                        no:17,
                        title:"Central Acute Vestibular Syndrome.",
                        video:"",
                        img:"VestibularSystem.jpg",
                        products:[
                            {
                                img:"strongboard.jpg",
                                caption:"StrongBoard Dynamic Stabilization Balance Board",
                                link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                            },
                            {
                                img:"balance-activity.jpg",
                                caption:"Hausmann Balance Activity Platform",
                                link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                            },
                            {
                                img:"Video-Frenzel-Vertigo.jpg",
                                caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                            },
                            {
                                img:"TQ-Solo.jpg",
                                caption:"TQ Solo Super Pulsed Lase",
                                link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                            },
                            {
                                img:"aeromat-elite.jpg",
                                caption:"Aeromat Elite Balance Beams, Set of 2",
                                link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                            },
                            {
                                img:"folding-balance.jpg",
                                caption:"EcoWise Folding Balance Beam",
                                link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                            },
                            {
                                img:"bed-wedge-pillow.jpg",
                                caption:"Bed Wedge Foam Positioning Pillow",
                                link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                            }
                        ]
                        },
                        {
                            no:18,
                            title:"Vestibular Neuritis",
                            video:"",
                            img:"vestibular-neuritis.png",
                            products:[
                                {
                                    img:"strongboard.jpg",
                                    caption:"StrongBoard Dynamic Stabilization Balance Board",
                                    link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                                },
                                {
                                    img:"balance-activity.jpg",
                                    caption:"Hausmann Balance Activity Platform",
                                    link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                                },
                                {
                                    img:"Video-Frenzel-Vertigo.jpg",
                                    caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                    link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                                },
                                {
                                    img:"TQ-Solo.jpg",
                                    caption:"TQ Solo Super Pulsed Lase",
                                    link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                                },
                                {
                                    img:"aeromat-elite.jpg",
                                    caption:"Aeromat Elite Balance Beams, Set of 2",
                                    link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                                },
                                {
                                    img:"folding-balance.jpg",
                                    caption:"EcoWise Folding Balance Beam",
                                    link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                                },
                                {
                                    img:"bed-wedge-pillow.jpg",
                                    caption:"Bed Wedge Foam Positioning Pillow",
                                    link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                                }
                            ]
                            },{
                                no:19,
                                title:"Labyrinthitis",
                                video:"",
                                img:"Labrynthitis.jpg",
                                products:[
                                    {
                                        img:"strongboard.jpg",
                                        caption:"StrongBoard Dynamic Stabilization Balance Board",
                                        link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                                    },
                                    {
                                        img:"balance-activity.jpg",
                                        caption:"Hausmann Balance Activity Platform",
                                        link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                                    },
                                    {
                                        img:"Video-Frenzel-Vertigo.jpg",
                                        caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                        link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                                    },
                                    {
                                        img:"TQ-Solo.jpg",
                                        caption:"TQ Solo Super Pulsed Lase",
                                        link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                                    },
                                    {
                                        img:"aeromat-elite.jpg",
                                        caption:"Aeromat Elite Balance Beams, Set of 2",
                                        link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                                    },
                                    {
                                        img:"folding-balance.jpg",
                                        caption:"EcoWise Folding Balance Beam",
                                        link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                                    },
                                    {
                                        img:"bed-wedge-pillow.jpg",
                                        caption:"Bed Wedge Foam Positioning Pillow",
                                        link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                                    }
                                ]
                                },{
                                    no:20,
                                    title:"pc-BPPV",
                                    video:"https://www.youtube.com/embed/lbPbM8018CE",
                                    thumbnail:'Epley Maneuver-20.jpg',
                                    // video:"https://drive.google.com/file/d/1QvkQOIhCgV7GCklTo9gl4QJXRbDJQQaw/preview",
                                    img:"",
                                    products:[
                                        {
                                            img:"strongboard.jpg",
                                            caption:"StrongBoard Dynamic Stabilization Balance Board",
                                            link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                                        },
                                        {
                                            img:"balance-activity.jpg",
                                            caption:"Hausmann Balance Activity Platform",
                                            link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                                        },
                                        {
                                            img:"Video-Frenzel-Vertigo.jpg",
                                            caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                            link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                                        },
                                        {
                                            img:"TQ-Solo.jpg",
                                            caption:"TQ Solo Super Pulsed Lase",
                                            link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                                        },
                                        {
                                            img:"aeromat-elite.jpg",
                                            caption:"Aeromat Elite Balance Beams, Set of 2",
                                            link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                                        },
                                        {
                                            img:"folding-balance.jpg",
                                            caption:"EcoWise Folding Balance Beam",
                                            link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                                        },
                                        {
                                            img:"bed-wedge-pillow.jpg",
                                            caption:"Bed Wedge Foam Positioning Pillow",
                                            link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                                        }
                                    ]
                                    },{
                                        no:21,
                                        title:"hc-BPPV",
                                        // video:"https://drive.google.com/file/d/1v80daWjeZZp9dgMEN8xuGH1w50cC4Y5l/preview",
                                        video:"https://www.youtube.com/embed/ZM7wlbaK_uc",
                                        thumbnail:'Gufoni Maneuver - 21.jpg',
                                        img:"",
                                        products:[
                                            {
                                                img:"strongboard.jpg",
                                                caption:"StrongBoard Dynamic Stabilization Balance Board",
                                                link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                                            },
                                            {
                                                img:"balance-activity.jpg",
                                                caption:"Hausmann Balance Activity Platform",
                                                link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                                            },
                                            {
                                                img:"Video-Frenzel-Vertigo.jpg",
                                                caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                                link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                                            },
                                            {
                                                img:"TQ-Solo.jpg",
                                                caption:"TQ Solo Super Pulsed Lase",
                                                link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                                            },
                                            {
                                                img:"aeromat-elite.jpg",
                                                caption:"Aeromat Elite Balance Beams, Set of 2",
                                                link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                                            },
                                            {
                                                img:"folding-balance.jpg",
                                                caption:"EcoWise Folding Balance Beam",
                                                link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                                            },
                                            {
                                                img:"bed-wedge-pillow.jpg",
                                                caption:"Bed Wedge Foam Positioning Pillow",
                                                link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                                            }
                                        ]
                                        },{
                                            no:22,
                                            title:"hc-BPPV",
                                            video:"https://www.youtube.com/embed/5FfzQQ5d060",
                                            thumbnail:'Gufoni Maneuver - 22.jpg',
                                            img:"",
                                            products:[
                                                {
                                                    img:"strongboard.jpg",
                                                    caption:"StrongBoard Dynamic Stabilization Balance Board",
                                                    link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                                                },
                                                {
                                                    img:"balance-activity.jpg",
                                                    caption:"Hausmann Balance Activity Platform",
                                                    link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                                                },
                                                {
                                                    img:"Video-Frenzel-Vertigo.jpg",
                                                    caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                                    link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                                                },
                                                {
                                                    img:"TQ-Solo.jpg",
                                                    caption:"TQ Solo Super Pulsed Lase",
                                                    link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                                                },
                                                {
                                                    img:"aeromat-elite.jpg",
                                                    caption:"Aeromat Elite Balance Beams, Set of 2",
                                                    link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                                                },
                                                {
                                                    img:"folding-balance.jpg",
                                                    caption:"EcoWise Folding Balance Beam",
                                                    link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                                                },
                                                {
                                                    img:"bed-wedge-pillow.jpg",
                                                    caption:"Bed Wedge Foam Positioning Pillow",
                                                    link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                                                }
                                            ]
                                            },{
                                                no:23,
                                                title:"Orthostatic Hypotension",
                                                video:"",
                                                img:"orthostatic-hypotension.png",
                                                products:[
                                                    {
                                                        img:"strongboard.jpg",
                                                        caption:"StrongBoard Dynamic Stabilization Balance Board",
                                                        link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                                                    },
                                                    {
                                                        img:"balance-activity.jpg",
                                                        caption:"Hausmann Balance Activity Platform",
                                                        link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                                                    },
                                                    {
                                                        img:"Video-Frenzel-Vertigo.jpg",
                                                        caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                                        link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                                                    },
                                                    {
                                                        img:"TQ-Solo.jpg",
                                                        caption:"TQ Solo Super Pulsed Lase",
                                                        link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                                                    },
                                                    {
                                                        img:"aeromat-elite.jpg",
                                                        caption:"Aeromat Elite Balance Beams, Set of 2",
                                                        link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                                                    },
                                                    {
                                                        img:"folding-balance.jpg",
                                                        caption:"EcoWise Folding Balance Beam",
                                                        link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                                                    },
                                                    {
                                                        img:"bed-wedge-pillow.jpg",
                                                        caption:"Bed Wedge Foam Positioning Pillow",
                                                        link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                                                    }
                                                ]
                                                },{
                no:24,
                title:"Motion Sickness",
                video:"",
                img:"motion-sickness.png",
                products:[
                    {
                        img:"strongboard.jpg",
                        caption:"StrongBoard Dynamic Stabilization Balance Board",
                        link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                    },
                    {
                        img:"balance-activity.jpg",
                        caption:"Hausmann Balance Activity Platform",
                        link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                    },
                    {
                        img:"Video-Frenzel-Vertigo.jpg",
                        caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                        link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                    },
                    {
                        img:"TQ-Solo.jpg",
                        caption:"TQ Solo Super Pulsed Lase",
                        link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                    },
                    {
                        img:"aeromat-elite.jpg",
                        caption:"Aeromat Elite Balance Beams, Set of 2",
                        link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                    },
                    {
                        img:"folding-balance.jpg",
                        caption:"EcoWise Folding Balance Beam",
                        link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                    },
                    {
                        img:"bed-wedge-pillow.jpg",
                        caption:"Bed Wedge Foam Positioning Pillow",
                        link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                    }
                ]
                },{
                no:26,
                title:"Effects of Aging",
                video:"",
                img:"aging-balance.png",
                products:[
                    {
                        img:"strongboard.jpg",
                        caption:"StrongBoard Dynamic Stabilization Balance Board",
                        link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                    },
                    {
                        img:"balance-activity.jpg",
                        caption:"Hausmann Balance Activity Platform",
                        link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                    },
                    {
                        img:"Video-Frenzel-Vertigo.jpg",
                        caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                        link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                    },
                    {
                        img:"TQ-Solo.jpg",
                        caption:"TQ Solo Super Pulsed Lase",
                        link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                    },
                    {
                        img:"aeromat-elite.jpg",
                        caption:"Aeromat Elite Balance Beams, Set of 2",
                        link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                    },
                    {
                        img:"folding-balance.jpg",
                        caption:"EcoWise Folding Balance Beam",
                        link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                    },
                    {
                        img:"bed-wedge-pillow.jpg",
                        caption:"Bed Wedge Foam Positioning Pillow",
                        link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                    }
                ]
                },{
                        no:27,
                        title:"Degenerative Illness",
                        video:"",
                        img:"",
                        products:[
                            {
                                img:"strongboard.jpg",
                                caption:"StrongBoard Dynamic Stabilization Balance Board",
                                link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                            },
                            {
                                img:"balance-activity.jpg",
                                caption:"Hausmann Balance Activity Platform",
                                link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                            },
                            {
                                img:"Video-Frenzel-Vertigo.jpg",
                                caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                            },
                            {
                                img:"TQ-Solo.jpg",
                                caption:"TQ Solo Super Pulsed Lase",
                                link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                            },
                            {
                                img:"aeromat-elite.jpg",
                                caption:"Aeromat Elite Balance Beams, Set of 2",
                                link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                            },
                            {
                                img:"folding-balance.jpg",
                                caption:"EcoWise Folding Balance Beam",
                                link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                            },
                            {
                                img:"bed-wedge-pillow.jpg",
                                caption:"Bed Wedge Foam Positioning Pillow",
                                link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                            }
                        ]
                        },{
                            no:28,
                            title:"Medications",
                            video:"",
                            img:"medications-dizziness.png",
                            products:[
                                {
                                    img:"strongboard.jpg",
                                    caption:"StrongBoard Dynamic Stabilization Balance Board",
                                    link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                                },
                                {
                                    img:"balance-activity.jpg",
                                    caption:"Hausmann Balance Activity Platform",
                                    link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                                },
                                {
                                    img:"Video-Frenzel-Vertigo.jpg",
                                    caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                    link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                                },
                                {
                                    img:"TQ-Solo.jpg",
                                    caption:"TQ Solo Super Pulsed Lase",
                                    link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                                },
                                {
                                    img:"aeromat-elite.jpg",
                                    caption:"Aeromat Elite Balance Beams, Set of 2",
                                    link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                                },
                                {
                                    img:"folding-balance.jpg",
                                    caption:"EcoWise Folding Balance Beam",
                                    link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                                },
                                {
                                    img:"bed-wedge-pillow.jpg",
                                    caption:"Bed Wedge Foam Positioning Pillow",
                                    link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                                }
                            ]
                            },{
                                no:29,
                                title:"PPPD",
                                video:"",
                                img:"pppd.jpg",
                                products:[
                                    {
                                        img:"strongboard.jpg",
                                        caption:"StrongBoard Dynamic Stabilization Balance Board",
                                        link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                                    },
                                    {
                                        img:"balance-activity.jpg",
                                        caption:"Hausmann Balance Activity Platform",
                                        link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                                    },
                                    {
                                        img:"Video-Frenzel-Vertigo.jpg",
                                        caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                        link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                                    },
                                    {
                                        img:"TQ-Solo.jpg",
                                        caption:"TQ Solo Super Pulsed Lase",
                                        link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                                    },
                                    {
                                        img:"aeromat-elite.jpg",
                                        caption:"Aeromat Elite Balance Beams, Set of 2",
                                        link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                                    },
                                    {
                                        img:"folding-balance.jpg",
                                        caption:"EcoWise Folding Balance Beam",
                                        link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                                    },
                                    {
                                        img:"bed-wedge-pillow.jpg",
                                        caption:"Bed Wedge Foam Positioning Pillow",
                                        link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                                    }
                                ]
                                },{
                                    no:30,
                                    title:"Mundane dizziness",
                                    video:"",
                                    img:"cure-mundane-dizziness.jpg",
                                    products:[
                                        {
                                            img:"strongboard.jpg",
                                            caption:"StrongBoard Dynamic Stabilization Balance Board",
                                            link:"https://www.rehabmart.com/product/strongboard-from-fabrication-enterprises-47468.html"
                                        },
                                        {
                                            img:"balance-activity.jpg",
                                            caption:"Hausmann Balance Activity Platform",
                                            link:"https://www.rehabmart.com/product/hausmann-balance-activity-platform-12780.html"
                                        },
                                        {
                                            img:"Video-Frenzel-Vertigo.jpg",
                                            caption:"Nystalab Wireless Video Frenzel Goggles for Dizziness and Vertigo",
                                            link:"https://www.rehabmart.com/product/nystalab-wireless-video-frenzel-system-for-visualization-and-analysis-of-eye-movements-47318.html"
                                        },
                                        {
                                            img:"TQ-Solo.jpg",
                                            caption:"TQ Solo Super Pulsed Lase",
                                            link: "https://www.rehabmart.com/product/tq-solo-cordless-super-pulsed-laser-15w-features-44283.html"
                                        },
                                        {
                                            img:"aeromat-elite.jpg",
                                            caption:"Aeromat Elite Balance Beams, Set of 2",
                                            link:"https://www.rehabmart.com/product/aeromat-elite-balance-beams-set-of-2-47002.html"
                                        },
                                        {
                                            img:"folding-balance.jpg",
                                            caption:"EcoWise Folding Balance Beam",
                                            link:"https://www.rehabmart.com/product/ecowise-folding-balance-beam-47003.html"
                                        },
                                        {
                                            img:"bed-wedge-pillow.jpg",
                                            caption:"Bed Wedge Foam Positioning Pillow",
                                            link:"https://www.rehabmart.com/product/bed-wedge5-34312.html"
                                        }
                                    ]}

            ]};
    }

   
    componentWillMount() {
      const {slide} =   this.props;
      const {slides} =   this.state;

      this.setState({selectedSlide: slides.filter((s,i)=> s.no === slide)[0]});
    }

    


    renderSlideDesc(){
        switch(this.props.slide){
            case 13:
               return <Meniere/>
            case 14:
                return <VestibularMigraine/>
            case 17:
                return <CAVS/>
            case 18:
                return <Neuritis/>
            case 19:
                return <Labyrinthitis/>
            case 20:
                return <BPPV/>
            case 21:
                return <HCBPPV/>
            case 22:
                return <GufoniGeotropic/>
            case 23:
                return <OH/>
            case 24:
                return <MotionSickness/>
            case 26:
                return <Aging/>
            case 27:
                return <DegenerativeIllness/>
            case 28:
                return <Medications/>
            case 29:
                return <PPPD/>
            case 30:
                return <MundaneDizziness/>
            default:
                return;
            
        }
    }
    

    componentDidMount(){
        window.scrollTo(0, 0);
    }
    
    render() {
        const {
            selectedSlide
          } = this.state;
        const {onClick, slide, onBack} = this.props;

        return (
            <section id="bg">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="rec">
                        <img src={df} alt="bk" />
                        <div className="rec-overlay text-center">
                            <p><span className="result">Your Results are In</span>
                            </p>
                            <h3>{selectedSlide.title}</h3>
                            {/* eslint-disable-next-line */}
                            <a className="but btn btn-danger" onClick={onClick.bind(this,3,false)}>TAKE THE TEST AGAIN <i className="fas fa-chevron-right"></i></a>
                            <div className="share">
                                 
                                Share on:
                                <Share/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <section id="white-bg">
                    { slide !== 1 && <div className="ml-4 link rel">
                                        {/* eslint-disable-next-line */}
                                        <a  href="#" onClick={onBack}><i className="fas fa-arrow-left"></i> Go Back</a>
                                    </div>}
                        <div className="container">
                            <div className="row">
                                <div className={selectedSlide.video || selectedSlide.img ? "col-lg-5" : "d-none"}>
                                    <div className="text-center">
                                        {selectedSlide.video && <VideoPlayer classNameThumbnail="mx-auto"  src={selectedSlide.video} thumbnail={selectedSlide.thumbnail} width="400" height="300"/> }
                                        {selectedSlide.img && <img className="result-img" alt="" src={require("../assets/images/results/" + selectedSlide.img)}/> }
                                        
                                    </div>
                                </div>
                                <div className={selectedSlide.video || selectedSlide.img ? "col-lg-7" : "col"}>
                                    <div className="vid-text">
                                         <ReactTooltip />
                                        {this.renderSlideDesc()}
                                    </div>
                                </div>
                            </div>
                            <section id="gray-bg">
                                <div className="container gray-bg">
                                   
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="what">
                                                <h2>What You Can Do Next</h2>
                                                <h5>Products for Treating Dizziness</h5>
                                                <p>Some dizziness disorders can be treated or diagnosed using these hand-selected products. Talk to your doctor and ask if any of these items can help your condition.</p>
                                                <hr/>
                                            </div>
                                        </div>
                                    </div>
                                    <Slider>
                                        {selectedSlide.products.map((s,i)=>{
                                            return <a href={s.link}  className="thumbnail-box text-center" target="blank" key={i}>
                                                    <img  src={require("../assets/images/products/" +s.img)} alt="" className="img-fluid"/>
                                                    <hr/>
                                                    <p>{s.caption}</p>
                                                    <hr/>
                                                   </a>
                                        })}
                                            
                                            
                                        
                                        </Slider>
                                        
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="last">
                                                <h5>See a Balance and Dizziness Specialist Near you</h5>
                                                <hr/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="map-text ">
                                                <p>Based on your input in the Rehabmart Virtual Dizzy Clinic, we recommend you begin your wellness journey with a Physical Therapist who specializes in balance and dizziness disorders.</p>
                                                <p>A specialist can guide you to the exact treatments, products and support that are best tailored for your particular situation</p>
                                                <p>Use the map to the right to find your nearest recommended</p>
                                                <p>Congratulations on taking the charge of your health and wellness. You are on your way!</p>

                                            </div>
                                        </div>
                                        <div className="col-lg-1"></div>
                                        <div className="col-lg-5">
                                            <div className="map d-block">
                                                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d7020396.089401588!2d-89.69275971431897!3d30.776606392876097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sfyzical%20in%20the%20united%20states!5e0!3m2!1sen!2sus!4v1569589149948!5m2!1sen!2sus" width="100%" frameBorder="0" style={{border:0}} allowFullScreen=""></iframe> */}
                                               <DoctorMaps/>
                                                
                                            </div>
                                            <p className="text-center map-caption">Open the map and zoom to your area to find the nearest recommended Balance Threapy specialist in your area. 
                                                </p>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </section>
                </div>
            </div>
           
        </div>
    </section>

        )
    }
}
